if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        this.detailsElements.length > 0 &&
          this.detailsElements.forEach((details) => {
            details.open ? this.handleOpen(details) : this.handleClose(details);
            details.addEventListener('toggle', this.onToggle.bind(this));
          });

        const showMoreBtn = this.querySelector('[data-collapsible-toggle]');
        if (showMoreBtn) {
          const moreItems = this.querySelector('.collapsible-tabs__more-items');
          showMoreBtn.addEventListener('click', () => {
            const isHidden = moreItems.hasAttribute('hidden');
            if (isHidden) {
              moreItems.removeAttribute('hidden');
              showMoreBtn.textContent = showMoreBtn.dataset.labelLess;
            } else {
              moreItems.setAttribute('hidden', '');
              showMoreBtn.textContent = showMoreBtn.dataset.labelMore;
            }
          });
        }
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.add(this.colorScheme);
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        parent.classList.contains('accordion-card') && parent.classList.remove(this.colorScheme);
      }
    }
  );
}
